import React from "react";
import { Modal, Form, Input, DatePicker, TimePicker, Select } from "antd";
const { Option } = Select;

export interface MediationFormData {
  mediationDate: string;
  mediationTime: string;
  mediationMode: string;
  mediationLink: string;
  meetingId: string;
  passcode: string;
}

interface MediationModalProps {
  open: boolean;
  onCancel: () => void;
  onSubmit: (formData: MediationFormData) => void;
}

const MediationModal: React.FC<MediationModalProps> = ({
  open,
  onCancel,
  onSubmit,
}) => {
  const [form] = Form.useForm();

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        const formattedData: MediationFormData = {
          mediationDate: values.mediationDate?.format("DD/MM/YYYY") || "",
          mediationTime: values.mediationTime?.format("hh:mm A") || "",
          mediationMode: values.mediationMode || "",
          mediationLink: values.mediationLink || "",
          meetingId: values.meetingId || "",
          passcode: values.passcode || "",
        };
        console.log(formattedData);
        onSubmit(formattedData);
        form.resetFields();
      })
      .catch((errorInfo) => {
        console.log("Validation Failed:", errorInfo);
      });
  };

  return (
    <Modal
      title="Mediation Details"
      open={open}
      onOk={handleOk}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      okText="Submit"
    >
      <Form layout="vertical" form={form} autoComplete="off">
        <Form.Item
          name="mediationDate"
          label="Date of Mediation"
          rules={[{ required: true, message: "Please select a date" }]}
        >
          <DatePicker style={{ width: "100%" }} format="DD/MM/YYYY" />
        </Form.Item>

        <Form.Item
          name="mediationTime"
          label="Time of Mediation"
          rules={[{ required: true, message: "Please select a time" }]}
          getValueFromEvent={(value) => value}
        >
          <TimePicker style={{ width: "100%" }} use12Hours format="h:mm a" />
        </Form.Item>

        <Form.Item
          name="mediationMode"
          label="Mode"
          rules={[{ required: true, message: "Please select a mode" }]}
        >
          <Select placeholder="Select mode">
            <Option value="Google Meet">Google Meet</Option>
            <Option value="In-person">In-person</Option>
            <Option value="Microsoft Teams">Microsoft Teams</Option>
            <Option value="Zoom">Zoom</Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="mediationLink"
          label="Link to Mediation Meeting"
          rules={[{ type: "url", message: "Please enter a valid URL" }]}
        >
          <Input placeholder="https://example.com/meeting" />
        </Form.Item>

        <Form.Item name="meetingId" label="Meeting ID">
          <Input
            placeholder="Enter Meeting ID (if applicable)"
            autoComplete="new-meeting-id"
          />
        </Form.Item>

        <Form.Item name="passcode" label="Meeting Passcode">
          <Input.Password
            placeholder="Enter passcode"
            autoComplete="new-password"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default MediationModal;
